<div class="bg-gray-50 rounded-2xl p-6 border border-gray-300">
  @if (isLoading || isLoadingDetalle) {
    <div class="bg-white rounded-xl border border-gray-200 p-8 min-h-[500px] flex items-center justify-center">
      <div class="text-center text-gray-600">
        <svg class="animate-spin w-16 h-16 mx-auto mb-4 text-[#e8343f]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-lg font-medium">Cargando información del vagón...</p>
      </div>
    </div>
  } @else if (error || !vagonDetalladoSeleccionado) {
    <div class="bg-white rounded-xl border border-gray-200 p-8 min-h-[500px] flex items-center justify-center">
      <div class="text-center text-gray-500">
        <svg class="w-16 h-16 mx-auto mb-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <p class="text-lg font-medium">Error al cargar información del vagón</p>
        <p class="text-sm mt-2">Por favor, intenta nuevamente</p>
      </div>
    </div>
  } @else {
    <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-6">
      <!-- Estadísticas de disponibilidad -->
      <div class="border-b border-gray-200 pb-4">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p class="text-sm text-gray-600">Aforo Total</p>
            <p class="text-2xl font-bold text-gray-900">{{ vagonDetalladoSeleccionado.aforo_maximo }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600">Disponibles</p>
            <p class="text-2xl font-bold text-green-600">{{ getDisponiblesCount() }}</p>
          </div>
          <div>
            <p class="text-sm text-gray-600">Reservados</p>
            <p class="text-2xl font-bold text-orange-600">{{ getReservadosCount() }}</p>
          </div>
        </div>
      </div>

      @if (vagonDetalladoSeleccionado.seatmap) {
        <!-- Con seatmap: mapa de asientos interactivo -->
        <div>
          <h3 class="text-lg font-semibold text-gray-800 mb-4">Selecciona tus asientos</h3>
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <p class="text-sm text-blue-800">
              💡 <strong>Haz click en un asiento</strong> para seleccionarlo y elegir el precio.
            </p>
          </div>
          <app-seat-map
            [tipoTicket]="vagonDetalladoSeleccionado"
            (seatClicked)="onSeatClicked($event)"
          />
        </div>
      } @else {
        <!-- Sin seatmap: selector normal de cantidad -->
        <app-ticket-selector
          [preloadedTipoTickets]="[vagonDetalladoSeleccionado]"
          [event]="event"
          [url_slug]="url_slug"
          (ticketsAdded)="ticketsAdded.emit()"
        />
      }
    </div>
  }
</div>

<!-- Modal para selección de precio -->
@if (showPriceModal && selectedSeatForModal) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <!-- Header del modal -->
      <div class="bg-gradient-to-r from-[#e8343f] to-red-600 text-white p-6 rounded-t-2xl">
        <div class="flex items-center justify-between">
          <div>
            <h2 class="text-2xl font-bold mb-1">🎫 Selecciona el precio</h2>
            <p class="text-red-100">Asiento: <strong>{{ selectedSeatForModal.secuencial }}</strong></p>
          </div>
          <button 
            (click)="closePriceModal()"
            [disabled]="isAddingToCart"
            class="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Contenido del modal -->
      <div class="p-6">
        <!-- Información del asiento -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div class="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p class="text-gray-600">Vagón</p>
              <p class="font-semibold text-gray-900">{{ vagonDetalladoSeleccionado?.nombre_localidad }}</p>
            </div>
            <div>
              <p class="text-gray-600">Asiento</p>
              <p class="font-semibold text-gray-900">{{ selectedSeatForModal.secuencial }}</p>
            </div>
            @if (selectedSeatForModal.row !== undefined && selectedSeatForModal.col !== undefined) {
              <!-- <div>
                <p class="text-gray-600">Posición</p>
                <p class="font-semibold text-gray-900">Fila {{ selectedSeatForModal.row + 1 }}, Columna {{ selectedSeatForModal.col + 1 }}</p>
              </div> -->
            }
            @if (selectedSeatForModal.direction) {
              <!-- <div>
                <p class="text-gray-600">Dirección</p>
                <p class="font-semibold text-gray-900">{{ selectedSeatForModal.direction }}</p>
              </div> -->
            }
          </div>
        </div>

        <!-- Selección de precios -->
        <h3 class="text-lg font-semibold text-gray-800 mb-4">Selecciona el tipo de precio:</h3>

        @if (preciosAgrupados.length > 0) {
          @for (grupo of preciosAgrupados; track grupo.grupo) {
            @if (grupo.grupo) {
              <h4 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2 mt-4 first:mt-0">
                {{ grupo.grupo }}
              </h4>
            }
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              @for (precio of grupo.precios; track getPrecioId(precio)) {
                <div
                  (click)="seleccionarPrecioEnModal(precio)"
                  [class.border-[#e8343f]]="getPrecioId(precioSeleccionado) === getPrecioId(precio)"
                  [class.bg-red-50]="getPrecioId(precioSeleccionado) === getPrecioId(precio)"
                  [class.ring-2]="getPrecioId(precioSeleccionado) === getPrecioId(precio)"
                  [class.ring-[#e8343f]]="getPrecioId(precioSeleccionado) === getPrecioId(precio)"
                  class="bg-white border-2 border-gray-200 rounded-lg p-4 cursor-pointer hover:border-[#e8343f] transition-all relative flex items-center justify-between"
                >
                  <div>
                    <p class="text-sm text-gray-600">{{ precio.nombre_precio }}</p>
                    <p class="text-xs text-gray-500 mt-1">{{ precio.nombre_moneda }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-2xl font-bold text-gray-900">${{ precio.precio_total.toFixed(2) }}</p>
                    @if (precio.precio_cargo_servicio > 0 || precio.precio_servicio_administrativo > 0) {
                      <!-- <p class="text-xs text-gray-500 mt-1">
                        @if (precio.precio_cargo_servicio > 0) {
                          Cargo servicio: ${{ precio.precio_cargo_servicio_final.toFixed(2) }}
                        }
                        @if (precio.precio_cargo_servicio > 0 && precio.precio_servicio_administrativo > 0) {
                          · 
                        }
                        @if (precio.precio_servicio_administrativo > 0) {
                          Serv. admin: ${{ precio.precio_servicio_administrativo_final.toFixed(2) }}
                        }
                      </p> -->
                    }
                  </div>
                  @if (getPrecioId(precioSeleccionado) === getPrecioId(precio)) {
                    <div class="absolute top-3 right-3 bg-[#e8343f] text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
                      ✓
                    </div>
                  }
                </div>
              }
            </div>
          }
        } @else {
          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p class="text-sm text-yellow-800">No hay precios disponibles para este vagón.</p>
          </div>
        }
      </div>

      <!-- Footer del modal -->
      <div class="bg-gray-50 px-6 py-4 rounded-b-2xl flex items-center justify-between border-t border-gray-200">
        <button 
          (click)="closePriceModal()"
          [disabled]="isAddingToCart"
          class="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancelar
        </button>
        
        @if (precioSeleccionado) {
          <button 
            (click)="confirmarYAgregarAsiento()"
            [disabled]="isAddingToCart"
            class="px-8 py-3 bg-[#e8343f] text-white rounded-lg font-bold hover:bg-red-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            @if (isAddingToCart) {
              <svg class="animate-spin w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Agregando...
            } @else {
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              Seleccionar Precio
            }
          </button>
        } @else {
          <button 
            disabled
            class="px-8 py-3 bg-gray-300 text-gray-500 rounded-lg font-bold cursor-not-allowed"
          >
            Selecciona un precio
          </button>
        }
      </div>
    </div>
  </div>
}



